<div class="container-fluid sl-form">

  <!-- ── CABECERA ── -->
  <div class="tf-page-header">
    <div class="d-flex align-items-center gap-2">
      <h4 class="tf-page-title mb-0">
        {{ salary.employee_name ? 'Editar nómina de ' + salary.employee_name : 'Nueva nómina' }}
      </h4>
      <ng-container *ngIf="saved">
        <mat-icon class="text-success">check_circle</mat-icon>
      </ng-container>
    </div>
    <button mat-stroked-button class="btn-convfact" (click)="save(salary)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

  <div *ngIf="ready">

    <!-- ── CARD: DATOS BÁSICOS ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>
        <div class="tf-section-header">
          <h6 class="tf-section-title">Datos del empleado</h6>
        </div>
        <div class="row g-3">

          <!-- Empleado -->
          <div class="col-sm-6 col-xl-4">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Empleado</mat-label>
                <input type="text" matInput placeholder="Buscar empleado..." required
                  [formControl]="employeesControl" [matAutocomplete]="autoName"
                  [value]="salary.employee_name ? salary.employee_name : ''">
                <mat-autocomplete #autoName="matAutocomplete">
                  <mat-option *ngFor="let option of employeesfilteredOptions | async; trackBy: trackByIndex"
                    [value]="option.name" (click)="setEmployeeIdentifier(option.uid)">
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
                <mat-icon matSuffix class="sl-spin-icon" *ngIf="showSpinnerCompanyName">autorenew</mat-icon>
              </mat-form-field>
              <app-help key='Gastos13'></app-help>
            </div>
          </div>

          <!-- Concepto -->
          <div class="col-sm-6 col-xl-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Concepto</mat-label>
              <input type="text" matInput name="salary.concept" required
                [(ngModel)]="salary.concept"
                [matAutocomplete]="autoConcept"
                (focus)="onConceptFocus()"
                (input)="onConceptInput($any($event.target).value)">
              <mat-autocomplete #autoConcept="matAutocomplete">
                <mat-option *ngFor="let opt of filteredConceptSuggestions; trackBy: trackByIndex" [value]="opt">
                  {{ opt }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Fecha -->
          <div class="col-sm-6 col-xl-4">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha</mat-label>
                <input matInput [matDatepicker]="date" name="salary.date"
                  [(ngModel)]="salary.date" required>
                <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                <mat-datepicker #date></mat-datepicker>
              </mat-form-field>
              <app-help key='Gastos14'></app-help>
            </div>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- ── CARD: DOCUMENTO DE LA NÓMINA (opcional) ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>
        <div class="tf-section-header">
          <h6 class="tf-section-title">Documento de la nómina</h6>
        </div>
        <span class="cf-dlg-section__label">PDF (opcional)</span>

        <ng-container *ngIf="!selectedFile">
          <div class="cf-dlg-upload-zone">
            <label class="cf-dlg-upload-btn" for="salary-pdf-input">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"/>
              </svg>
              Seleccionar PDF
            </label>
          </div>
          <input id="salary-pdf-input" type="file" (change)="onFileSelected($event)" accept="application/pdf" style="display:none">
        </ng-container>

        <div class="cf-dlg-upload-success" *ngIf="selectedFile">
          <mat-icon>check_circle</mat-icon>
          {{ selectedFile.name }}
          <button mat-icon-button (click)="removeSelectedFile()" style="margin-left:auto" title="Quitar archivo">
            <mat-icon style="font-size:16px; color:var(--cf-text-muted)">delete</mat-icon>
          </button>
        </div>

        <p style="margin:8px 0 0; font-size:12px; color:var(--cf-text-muted, #6b7280);">
          Opcional — si no lo adjuntas ahora, podrás hacerlo después desde el listado de nóminas.
        </p>
      </mat-card-content>
    </mat-card>

    <!-- ── CARD: CIFRAS DE NÓMINA ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>
        <div class="tf-section-header">
          <h6 class="tf-section-title">Cifras de la nómina</h6>
        </div>

        <div class="row g-3">

          <!-- Salario Bruto -->
          <div class="col-sm-6 col-lg-3">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Salario bruto</mat-label>
                <span matSuffix class="sl-euro-suffix">€</span>
                <input type="text" matInput name="salary.salaryBrut" required
                  [(ngModel)]="salary.salaryBrut" numberDecimalsDirective>
              </mat-form-field>
              <app-help key='Gastos15'></app-help>
            </div>
          </div>

          <!-- IRPF -->
          <div class="col-sm-6 col-lg-3">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>IRPF</mat-label>
                <span matSuffix class="sl-euro-suffix">€</span>
                <input type="text" matInput name="salary.irpf" required
                  [(ngModel)]="salary.irpf" numberDecimalsDirective>
              </mat-form-field>
              <app-help key='Gastos16'></app-help>
            </div>
          </div>

          <!-- SS Trabajador -->
          <div class="col-sm-6 col-lg-3">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>SS trabajador</mat-label>
                <span matSuffix class="sl-euro-suffix">€</span>
                <input type="text" matInput name="salary.segSocialWorker"
                  [(ngModel)]="salary.segSocialWorker" numberDecimalsDirective>
              </mat-form-field>
              <app-help key='Gastos18'></app-help>
            </div>
          </div>

          <!-- SS Empresa -->
          <div class="col-sm-6 col-lg-3">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>SS empresa</mat-label>
                <span matSuffix class="sl-euro-suffix">€</span>
                <input type="text" matInput name="salary.segSocialCompany"
                  [(ngModel)]="salary.segSocialCompany" numberDecimalsDirective>
              </mat-form-field>
              <app-help key='Gastos19'></app-help>
            </div>
          </div>

          <!-- Otras deducciones -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Otras deducciones</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.otherDeductions"
                [(ngModel)]="salary.otherDeductions" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Anticipos -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Anticipos</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.advancePayments"
                [(ngModel)]="salary.advancePayments" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Salario en especie -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Salario en especie</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.salaryInKind"
                [(ngModel)]="salary.salaryInKind" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- IRPF en especie -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>IRPF en especie</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.irpfnKind"
                [(ngModel)]="salary.irpfnKind" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Percepciones incapacidad -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Percepciones incapacidad laboral</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.paymentsForIncapacityForWork"
                [(ngModel)]="salary.paymentsForIncapacityForWork" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- IRPF incapacidad -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>IRPF por incapacidad laboral</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.personalIncomeTaxOnPaymentsForIncapacityForWork"
                [(ngModel)]="salary.personalIncomeTaxOnPaymentsForIncapacityForWork"
                numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Salario exento -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Salario exento</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.exemptSalary"
                [(ngModel)]="salary.exemptSalary" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Salario en especie exento -->
          <div class="col-sm-6 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Salario en especie exento</mat-label>
              <span matSuffix class="sl-euro-suffix">€</span>
              <input type="text" matInput name="salary.exemptSalaryInKind"
                [(ngModel)]="salary.exemptSalaryInKind" numberDecimalsDirective>
            </mat-form-field>
          </div>

        </div>

        <!-- Barra Salario Neto -->
        <div class="pf-section-divider mt-3"></div>
        <div class="pf-totals-bar">
          <div class="pf-totals-bar__items">
            <span class="sl-net-label">Salario neto</span>
          </div>
          <div class="sl-net-field">
            <div class="sv-field-help">
              <mat-form-field appearance="outline" class="sl-net-input">
                <span matSuffix class="sl-euro-suffix">€</span>
                <input type="text" matInput name="salary.salaryNet" required
                  [(ngModel)]="salary.salaryNet" numberDecimalsDirective
                  (focus)="onFocusSalaryNet()">
              </mat-form-field>
              <app-help key='Gastos20'></app-help>
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>

    <!-- ── CARD: CATEGORIZACIÓN (condicional) ── -->
    <mat-card appearance="outlined" class="tf-card mb-3"
      *ngIf="(isProjectEnable && (projects?.length > 0 || expenseProjectTypes?.length > 0)) || (companyModeService.mode$ | async) === 'nonprofit'">
      <mat-card-content>
        <div class="tf-section-header">
          <h6 class="tf-section-title">Categorización</h6>
        </div>
        <div class="row g-3">

          <div class="col-sm-6" *ngIf="isProjectEnable && projects?.length > 0">
            <app-autocomplete-select
              [items]="projects" [(selectedItemId)]="salary.projectUid"
              [idField]="'id'" [displayField]="'display'"
              placeholder="Proyecto" [classList]="'sl-field-full'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6" *ngIf="isProjectEnable && expenseProjectTypes?.length > 0">
            <app-autocomplete-select
              [items]="expenseProjectTypes" [(selectedItemId)]="salary.expenseProjectTypeUid"
              [idField]="'id'" [displayField]="'display'"
              placeholder="Tipo de gasto del Proyecto" [classList]="'sl-field-full'">
            </app-autocomplete-select>
          </div>

          <!-- Clasificador de gastos (subpartida de "1. Gastos de personal") - solo asociaciones/fundaciones -->
          <ng-container *appCompanyMode="'nonprofit'">
            <div class="col-sm-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Clasificación (Gastos de personal)</mat-label>
                <mat-select [(ngModel)]="salary.clasificadorSubpartida" name="salary.clasificadorSubpartida">
                  <mat-option *ngFor="let subpartida of clasificadorSubpartidas" [value]="subpartida">
                    {{ subpartida }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>

        </div>
      </mat-card-content>
    </mat-card>

  </div>

</div>
